module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedExtraBold.139a6ca.woff2";